export default "__VITE_ASSET__7eb28699__"